import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { NotificationService } from '@clean-code/notifications/domain';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBell, faBellOn } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoModule } from '@jsverse/transloco';
import { HubConnectionState } from '@microsoft/signalr';
import { NotificationBellComponent } from './notification-bell/notification-bell.component';
import { NotificationHostComponent } from './notification-host/notification-host.component';

@Component({
  selector: 'notifications-notification-center',
  templateUrl: './notification-center.component.html',
  styleUrls: ['./notification-center.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FontAwesomeModule,
    MatMenuModule,
    TranslocoModule,
    NotificationHostComponent,
    NotificationBellComponent,
  ],
})
export class NotificationCenterComponent {
  private notificationService = inject(NotificationService);
  public unreadCount = this.notificationService.unreadCount;
  public connectionState = this.notificationService.connectionState;
  public messages = this.notificationService.messages;

  public faBell = faBell;
  public faBellOn = faBellOn;
  public connectedState = HubConnectionState.Connected;

  public setAllRead($event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();

    this.notificationService.setAllAsRead();
  }

  public getBellAnimationClass(unreadCount: number): string {
    if (unreadCount >= 20) {
      return 'bell-icon animate-20';
    } else if (unreadCount >= 5) {
      return 'bell-icon animate-5';
    }
    return 'bell-icon';
  }
}
